var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-6-wrapper"},[_c('img',{staticClass:"bg",attrs:{"src":_vm.source('page-6-bg'),"alt":"","draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }